<template>
  <div>
    <template v-if="canVerb(resource, 'index')">
      <actions-toolbar>
        <template #filters>
          <div class="status-filter">
            <div class="pill-wrapper my-3">
              <span
                class="pill"
                v-for="(value, name, index) in activeFilters"
                :key="index"
                data-color="white"
              >
                <span v-b-toggle.sidebar-1 :data-filter="name"
                  ><strong>{{ sidebarFilterName(name, context) }}</strong
                  >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
                >
                <span tabindex="0">
                  <span
                    @click="resetSingleSidebarFilter(name)"
                    title="Rimuovi filtro"
                    >×</span
                  >
                </span>
              </span>
              <template v-if="countActiveFilters">
                <span
                  class="pill"
                  data-color="alert"
                  @click="resetAllFilters()"
                  title="Rimuovi i filtri e ricarica la tabella"
                >
                  <span
                    ><strong>Reset ({{ countActiveFilters }})</strong></span
                  >
                  <span><span>×</span></span>
                </span>
              </template>
            </div>
          </div>
        </template>
        <b-button-group
          v-b-toggle:sidebar-1
          :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
            countActiveFilters ? ' active' : ''
          }`"
          :title="getDefaultFilterMessage()"
        >
          <base-icon name="filters" width="23" height="23" />
          <span style="font-size: 14px; font-weight: 500">
            {{ computedFilterTitle }}
          </span>
        </b-button-group>
        <export-options
          :exportUrl="exportUrl"
          :repository="repository"
          :resource="resource"
          :tableRef="$refs[tableRef]"
          :filter="filter"
          :options="[
            {
              code: 'EXPOLITI',
              label: null,
              formats: ['csv', 'pdf'],
            },
          ]"
        ></export-options>
      </actions-toolbar>
      <div class="table-container">
        <b-sidebar
          id="sidebar-1"
          :title="computedFilterTitle"
          :backdrop="true"
          width="25vw"
          shadow
          right
          :visible="open_filter"
          :data-open="open_filter"
          @change="onSidebarFilterChange"
        >
          <b-form @submit.prevent="onSearch(filterName)">
            <div class="filter">
              <div class="filter-item">
                <base-select
                  name="Stato Lisapay"
                  label="Stato Lisapay"
                  v-model="filter.byAttribute.lisapay_paid"
                  :options="[
                    { value: 0, text: 'Non Pagato' },
                    { value: 1, text: 'Pagato' },
                  ]"
                  :disabled="true"
                />
              </div>
              <div class="filter-item">
                <base-select
                  name="Stato Titoli"
                  label="Stato Titoli"
                  v-model="filter.byAttribute.status_ancillary"
                  :options="titoli"
                />
              </div>
              <div class="filter-item">
                <base-select
                  name="tipo_titoli"
                  label="Registrato in Compagnia"
                  v-model="filter.byAttribute.registered"
                  :options="[
                    { value: 0, text: 'No' },
                    { value: 1, text: 'Sì' },
                  ]"
                />
              </div>
              <div class="filter-item">
                <base-select
                  name="cod_prod"
                  label="Produttore"
                  :options="salesmen_select"
                  v-model="filter.byBroker.id"
                  :multiple="true"
                  :taggable="salesmen_taggable"
                  :defaultHtmlMultipleSelect="true"
                  :closeOnSelect="false"
                  @changeTaggable="changeTaggable"
                />
                <div class="d-flex" style="gap: 10px">
                  <b-button
                    :pressed.sync="myToggle"
                    variant="light"
                    class="mt-1 btn--x-smaller btn--smaller btn--transparent"
                    @click="
                      myToggle ? selectAllBrokers() : deselectAllBrokers()
                    "
                    >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
                  </b-button>
                  <b-button
                    :pressed.sync="myTogglePO"
                    variant="light"
                    class="btn--smaller mt-1 btn--x-smaller btn--transparent"
                    @click="
                      myTogglePO ? salesmenOrderByCode() : salesmenOrderByName()
                    "
                    >{{ myTogglePO ? "Ordine per nome" : "Ordina per codice" }}
                  </b-button>
                </div>
              </div>
              <div class="filter-item">
                <base-datepicker
                  name="data_pagamento_su_lisapay_da"
                  label="Data pagamento su Lisapay da"
                  v-model="filter.byLisapayPaidAt.from"
                />
              </div>
              <div class="filter-item">
                <base-datepicker
                  name="data_pagamento_su_lisapay_a"
                  label="Data pagamento su Lisapay a"
                  v-model="filter.byLisapayPaidAt.to"
                />
              </div>
            </div>
            <div class="actions-filter-sidebar-wrapper">
              <b-button
                type="submit"
                variant="lisaweb"
                size="sm"
                v-b-toggle:sidebar-1
                >Cerca
              </b-button>
              <b-button
                class="btn--transparent btn-reset"
                type="button"
                size="sm"
                @click="onClearFilter(filterName)"
                >Reset
              </b-button>
            </div>
          </b-form>
        </b-sidebar>
        <!-- <button-group-table
          @csv="onExport('csv')"
          :options="{
            CSV: { enabled: true },
          }"
        ></button-group-table> -->
        <insurance-ancillaries
          @edit="onEdit"
          @manualFetch="manualFetch"
          :fields="fields"
          :repository="repository"
          :resource="resource"
          :filterOn="{
            byRelations: [
              'byBookEntry',
              'byRegistry',
              'byBroker',
              'byInsurerParticipant',
              'byLisapayProceed',
            ],
          }"
          :filterName="filterName"
          :performedSearch="computePerformedSearch"
          :filterCount="countActiveFilters"
          :onlyActions="['lisapay_register_to_company']"
          :ref="tableRef"
          @rowSelector="onAddBookEntry"
          includeRowSelector
          sortField="lisapay_paid_at"
          :total_deferred="total_deferred"
          :isLisapay="true"
        ></insurance-ancillaries>

      </div>
    </template>
  </div>
</template>

<script>
import InsuranceAncillaries from "@/components/tables/InsuranceAncillaries";
import { prepareFilterQueryString } from "@/utils/forms";
import ExportOptions from "@/components/ExportOptions";
// import BaseInput from "@/components/form/BaseInput";
// import ButtonGroupTable from "@/components/ButtonGroupTable";
// import ExportOptions from "@/components/ExportOptions";
import BaseSelect from "@/components/form/BaseSelect";
import BaseIcon from "../../BaseIcon.vue";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
// import QuickSearchRegistryModal from "@/components/modals/quickSearchRegistry";
// import QuickSearchPolicyModal from "@/components/modals/quickSearchPolicy";
// import QuickSearchGroupModal from "@/components/modals/quickSearchGroup";
import { toLocaleCurrency } from "@/utils/strings";
import { toInfoData } from "@/utils/transforms";
import { today, toLocaleDate } from "@/utils/dates";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";

moment.locale("it");

// import ExportsMixin from "@/mixins/ExportsMixin";

export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      exportUrl: null,
      filter: this.initFilter(),
      activeFilters: {},
      companies: [],
      status_policy_opt: [
        { value: "0", text: "Non perfezionata" },
        { value: "1", text: "Perfezionata" },
        { value: "2", text: "Sospesa" },
        { value: "3", text: "Sostituita" },
        { value: "10", text: "Stornata" },
        { value: "4", text: "Annullata" },
        { value: "5", text: "Scaduta" },
        { value: "6", text: "Svincolata" },
        { value: "7", text: "Abbandonata" },
        { value: "8", text: "Disdetta" },
        { value: "9", text: "Nuova viva" },
      ],
      tableRef: "InsuranceAncillariesLisapayTableRef",
      filterName: "filterInsuranceAncillariesLisapay",
      resource: "insurance_ancillaries",
      repository: "insurance_ancillary",
      context: "lisapay_insurance_ancillary",
      registry_data: null,
      insurance_policy_data: null,
      group_data: null,
      risks: [],
      notes: [],
      total_deferred: {
        isLoading: true,
        total: null,
      },
      form: {
        inpt_label_policy: "",
        inpt_label_registry: "",
        inpt_label_group: "",
        quick_value: "",
      },
      fields: [
        // {
        //   key: "rowSelector",
        //   label: "Incassa",
        //   sortable: false,
        //   thStyle: {
        //     width: "20px",
        //   },
        // },
        // Stato Lisapay come badge (lisapayStatus in utils/statusBadge.js).
        {
          key: "lisapay_status",
          label: "Stato",
          sortable: false,
          tdClass: "text-nowrap",
        },
        {
          key: "lisapay_paid_at",
          label: this.getDictionary("lisapay_paid_at", "insurance_ancillary"),
          sortable: true,
          sortKey: "byAttribute.lisapay_paid_at",
          stickyColumn: true,
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "registered_at",
          label: this.getDictionary("registered_at", "insurance_ancillary"),
          sortable: true,
          sortKey: "byAttribute.registered_at",
          stickyColumn: true,
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "book_date",
          label: this.getDictionary("book_date", "insurance_ancillary"),
          sortable: false,
          stickyColumn: true,
        },
        {
          key: "insurer",
          label: this.getDictionary("insurer"),
          sortable: false,
          stickyColumn: true,
        },
        {
          key: "broker_by_id",
          label: this.getDictionary("salesman"),
          sortable: false,
          stickyColumn: true,
        },
        {
          key: "insurance_policy_insurer",
          label: this.getDictionary(
            "insurance_policy_id",
            "insurance_ancillary",
          ),
          sortable: true,
          sortKey: "byInsurancePolicy.number",
        },
        // {
        //   key: "cooperators",
        //   label: this.getDictionary("cooperators", "insurance_ancillary"),
        // },
        // {
        //   key: "code.value",
        //   label: this.getDictionary("code", "insurance_ancillary"),
        //   sortKey: "code",
        //   sortable: true,
        // },
        // {
        //   key: "insurance_policy.insurance_risk.risk_branch.formatted_title",
        //   label: this.getDictionary("title", "risk_branch"),
        //   sortable: true,
        //   sortKey: "byRiskBranch.title",
        // },
        // {
        //   key: "insurance_policy.title",
        //   label: this.getDictionary("Descrizione Polizza"),
        //   sortable: true,
        //   sortKey: "byInsurancePolicy.title",
        // },
        {
          key: "customer",
          label: this.getDictionary("contractor"),
          sortable: true,
          sortKey: "byRegistry.title",
        },
        // {
        //   key: "address_book",
        //   label: this.getDictionary("address_book"),
        //   sortable: false,
        // },
        // {
        //   key: "primary_group",
        //   label: this.getDictionary("primary_group"),
        //   sortable: true,
        //   sortKey: "byRegistryGroup.code",
        // },
        {
          key: "gross",
          label: this.getDictionary("gross", "insurance_ancillary"),
          formatter: (value) => toLocaleCurrency(value),
          sortable: true,
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "collected",
          label: this.getDictionary("collected", "insurance_ancillary"),
          sortable: false,
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        // {
        //   key: "status_ancillary.text",
        //   label: this.getDictionary("status_ancillary", "insurance_ancillary"),
        //   sortable: true,
        //   sortKey: "status_ancillary",
        // },
        // {
        //   key: "delay_days",
        //   label: this.getDictionary("delay_days", "insurance_ancillary"),
        //   sortable: false,
        // },
        // {
        //   key: "broker",
        //   label: this.getDictionary("broker_id", "insurance_ancillary"),
        //   sortable: true,
        //   sortKey: "byBroker.BUID",
        // },
        // {
        //   key: "insurance_payments",
        //   label: "Commento QT",
        //   sortable: false,
        //   formatter: (value) => this.retrieveComment(value),
        // },
        // {
        //   key: "note_counter",
        //   label: this.getDictionary("Note"),
        //   sortable: false,
        // },
        {
          key: "effective_at",
          label: this.getDictionary("effective_at", "insurance_ancillary"),
          sortable: true,
          sortKey: "byAttribute.effective_at",
          stickyColumn: true,
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "delay_until",
          formatter: (value) => toLocaleDate(value),
          sortable: true,
          label: this.getDictionary("delay_until", "insurance_ancillary"),
        },
        {
          key: "charge_error",
          formatter: (value) => (value ? value : "-"),
          sortable: false,
          label: this.getDictionary("charge_error", "insurance_ancillary"),
        },
        {
          key: "lisabbina",
          label: "Lisabbina",
          sortable: false,
        },
      ],
      myToggle: false,
      myTogglePO: false,
      // salesmen_ids: [],
      // salesman_id: null,
      salesmen: [],
      salesmen_ordered: [],
      salesmen_select: [],
      salesmen_taggable: true,
      cooperators: [],
      titoli: [
        { value: "0", text: "Da incassare" },
        { value: "1", text: "Incassato" },
        { value: "2", text: "Stornati" },
        { value: "3", text: "Annullati manualmente" },
        { value: "4", text: "Annullati manualmente + annullo polizza" },
        { value: "5", text: "Annullati su piattaforma compagnia" },
        { value: "6", text: "Annullati per sostituzione" },
        { value: "7", text: "Da validare" },
      ],
      tipo_titoli: [
        { value: "P", text: "Polizze" },
        { value: "Q", text: "Quietanze" },
        { value: "A", text: "Appendici" },
        // { value: "X", text: "Pregresso" },
      ],
      opt_status: [
        { value: "expired", text: "Scaduti" },
        { value: "last_day", text: "Ultimo giorno di mora" },
        { value: "ending", text: "In scadenza" },
        { value: "valid", text: "Validi" },
      ],
    };
  },
  components: {
    // BaseInput,
    // ButtonGroupTable,
    // ExportOptions,
    BaseIcon,
    ExportOptions,
    BaseSelect,
    BaseDatepicker,
    InsuranceAncillaries,
    // QuickSearchRegistryModal,
    // QuickSearchPolicyModal,
    // QuickSearchGroupModal,
  },
  methods: {
    toInfoData,
    prepareFilterQueryString,
    selectAllBrokers() {
      this.filter.byBroker.id = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
      // this.onSalesmen();
    },
    deselectAllBrokers() {
      this.filter.byBroker.id = null;
    },
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    retrieveComment(value) {
      return value?.[0]?.comment ? value[0].comment : "-";
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    initFilter() {
      let init = {
        byAttribute: {
          lisapay_paid: 1,
          status_ancillary: null,
          registered: null,
        },
        // byCustom: {
        //   lisapay_paid_at: {
        //     value: today(),
        //     likewise: 3,
        //     filter: "byAttribute",
        //   },
        // },
        byLisapayPaidAt: {
          from: today(),
          to: today(),
        },
        byBroker: {
          id: null,
        },
        // byCollaborator: {
        //   id: null,
        // },
        // byRegistry: {
        //   id: null,
        //   null: null,
        // },
        // byRiskType: {
        //   id: null,
        // },
        // byRegistryGroup: {
        //   code: null,
        // },
        // byInsurer: {
        //   id: null,
        // },
        // byInsurancePolicy: {
        //   id: null,
        //   number: null,
        //   status_policy: null,
        // },
        // byInsurancePayment: {
        //   comment: null,
        // },
        // byStocastico: {
        //   date: moment().format("YYYY-MM-DD"),
        //   status: [],
        // },
        // byCalendar: {
        //   from: null,
        //   to: null,
        // },
      };
      return init;
    },
    onAddBookEntry(row) {
      this.removeQuickSearchByName(this.filterName);
      this.$router.push({
        name: `book_entries.create`,
        params: {
          mode: "IV",
          titleId: row.id,
          insuranceRiskId: row.insurance_risk_id,
        },
      });
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      this.onSearch(this.filterName);
    },
    onAdd() {
      this.$router.push({ name: `${this.resource}.create` });
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(id) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${id}` },
      });
    },
    onDestroy(id) {
      // console.debug("DESTROYING id:", id);
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          // console.debug("successfully deleted!");
          this.$refs[this.tableRef].fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      this.isLoading = true;
      // console.log(name, "test");
      let criteria = this.filter;
      // console.log("Filter: ", this.filter);
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      // console.log(this.$refs[this.tableRef]);
      // this.$refs[this.tableRef].fetch();
      // TODO
      // Trovare il punto dove viene eliminato il filter al cambio modulo e aggiungerci l'eliminazione del quicksearch
      // quicksearch
      criteria = {};

      ["quickSearchPolicy", "quickSearchRegistry", "quickSearchGroup"].forEach(
        (element) => {
          criteria[element] = {
            label: "",
            formLabel: "",
            data: null,
            formData: null,
          };
        },
      );
      criteria.quickSearchPolicy.label = this.form.inpt_label_policy;
      criteria.quickSearchPolicy.formLabel = "form.inpt_label_policy";
      criteria.quickSearchPolicy.data = this.insurance_policy_data;
      criteria.quickSearchPolicy.formData = "insurance_policy_data";
      criteria.quickSearchRegistry.label = this.form.inpt_label_registry;
      criteria.quickSearchRegistry.formLabel = "form.inpt_label_registry";
      criteria.quickSearchRegistry.data = this.registry_data;
      criteria.quickSearchRegistry.formData = "registry_data";
      criteria.quickSearchGroup.label = this.form.inpt_label_group;
      criteria.quickSearchGroup.formLabel = "form.inpt_label_group";
      criteria.quickSearchGroup.data = this.group_data;
      criteria.quickSearchGroup.formData = "group_data";
      this.saveQuickSearchByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      // REVIEW
      // NOTE
      // per tutte le index con quickSearch
      // finché non si trova il modo di "fillare" anche i dati delle quicksearch memorizzati nel criteria,
      // non è possibile consentire alla index di far autofecth, poichè non si vede nelle quicksearch che viene applicato
      // anche quel filtro!!! perciò, eliminiamo subito il filtro.
      // this.$refs[this.tableRef].fetch().then(() => {
      //   this.removeFilterByName(name);
      //   this.removeQuickSearchByName(name);
      // });

      this.total_deferred = {
        isLoading: true,
        total: null,
      };
      this.$refs[this.tableRef]
        .fetch()
        .then(() => {
          // story-681
          if (this.filter.byAttribute.code === "!X") {
            this.filter.byAttribute.code = [];
          }

          this.loadDeferredTotal();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: errMsg });
          this.isLoading = false;
        });
    },
    loadDeferredTotal() {
      const Repo = RepositoryFactory.get("lisapay_proceed");

      const qs = `byType=insurance_ancillary&byAttribute[paid]=1&byPaidAt=${
        this.filter.byLisapayPaidAt.from ?? today()
      },${this.filter.byLisapayPaidAt.to ?? today()}`;

      this.isLoading = true;

      return Repo.collectedAmount(qs)
        .then((response) => {
          this.total_deferred.total = response?.data?.amount
            ? Number(parseFloat(response.data.amount).toFixed(2))
            : 0;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: errMsg });
        })
        .finally(() => {
          this.total_deferred.isLoading = false;
          this.isLoading = false;
        });
    },
    onClearFilter(name) {
      // this.resetPolicyId();
      // this.resetRegistryId();
      // this.resetGroupId();
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removeQuickSearchByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "lisapay_paid_at";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    handleRegistryModalInput(value) {
      this.filter.byRegistry.id = value.id;
      this.registry_data = value;
      this.form.inpt_label_registry = this.toInfoData(
        this.registry_data,
        "registryfullname",
      );
      this.$bvModal.hide("quickSearchRegistryModal");
    },
    openQuickSearchRegistry() {
      this.filter.byRegistry.id = null;
      this.$bvModal.show("quickSearchRegistryModal");
    },
    resetRegistryId() {
      this.registry_data = null;
      this.form.inpt_label_registry = null;
      this.filter.byRegistry.id = null;
    },
    handlePolicyModalInput(value) {
      this.form.quick_value = value.id;
      this.filter.byInsurancePolicy.id = value.id;
      this.form.inpt_label_policy = value.number;
      this.insurance_policy_data = value;
      this.$bvModal.hide("quickSearchPolicyModal");
    },
    openQuickSearchPolicy() {
      this.form.quick_value = null;
      this.$bvModal.show("quickSearchPolicyModal");
    },
    resetPolicyId() {
      this.insurance_policy_data = null;
      this.form.inpt_label_policy = null;
      this.filter.byInsurancePolicy.id = null;
    },
    handleGroupModalInput(value) {
      this.filter.byRegistryGroup.code = value.code;
      this.group_data = value;
      this.form.inpt_label_group = this.toInfoData(
        this.group_data,
        "registry_group",
      );
      this.$bvModal.hide("quickSearchGroupModal");
    },
    openQuickSearchGroup() {
      this.filter.byRegistryGroup.code = null;
      this.$bvModal.show("quickSearchGroupModal");
    },
    resetGroupId() {
      this.group_data = null;
      this.form.inpt_label_group = null;
      this.filter.byRegistryGroup.code = null;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("quicksearch", {
      saveQuickSearchByName: "saveByName",
      removeQuickSearchByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    ...mapGetters("auth", {
      getInsurers: "insurers",
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
      getCooperators: "cooperators",
      getRisks: "risks",
    }),
  },
  computed: {
    agencyHasFee() {
      return this.$store.state.auth.use_fee === "Y" ? true : false;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
  },
  // beforeMount() {
  //  this.isLoading = true;
  // // #1153 se non c'è già un filtro salvato, imposto i valori di default
  // let found = this.loadFilter(this.filterName);
  // if (!found) {
  //   this.$set(this, "filter", this.initFilter());
  // } else {
  //   this.$set(this, "filter", found);
  // }
  // },
  mounted() {
    this.companies = this.getInsurers();
    this.salesmen = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    this.salesmen_select = this.salesmen;
    this.risks = this.getRisks();
  },
  created() {
    if (this.agencyHasFee) {
      const feeGrossField = {
        key: "fee_gross",
        label: this.getDictionary("fee_gross", "insurance_ancillary"),
        formatter: (value) => toLocaleCurrency(value),
        sortable: true,
        thClass: "text-right",
        thStyle: {
          "text-align": "right",
        },
        tdClass: "text-right",
      };
      this.fields.splice(11, 0, feeGrossField);
    }
    /* */
    const path = "auth/";
    const resources = [];
    /* Uncommented because of the missing import of quickSearchRegistry */
    if (!this.hasLoadedResource("councils"))
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {
            console.info(`background data "${path}councils" fetched correctly`);
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("provinces"))
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {
            console.info(
              `background data "${path}provinces" fetched correctly`,
            );
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("countries")) {
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {
            console.info(
              `background data "${path}countries" fetched correctly`,
            );
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    }
    if (!this.hasLoadedResource("cooperators")) {
      resources.push(
        this.$store
          .dispatch(`${path}cooperators`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    } else {
      this.cooperators = this.getCooperators();
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          this.cooperators = this.getCooperators();
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
  },
  // beforeDestroy() {
  //   this.onClearFilter(this.filterName);
  // },
};
</script>

